/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "./subscriptionAdjustment.module.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";
import { Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { withTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import { IconButton } from "@mui/material";
import {
  ActivateIcon,
  AutoActivatedIcon,
  ResendEmailIcon,
} from "../../../component/icons/icons";
import { formatNumber } from "../../../helper/numberFormatter";
import {formatDate} from "../../../helper/dateFormatter";

const subscriptionAdjustmentTable = (props) => {
  return (
    <div className={classes.root}>
      <TableContainer>
        <Table
          className={classes.table + " " + "newGlobalTable"}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("subAdjustmentId");
                }}
              >
                <b>{props.t("SUB_ADJUSTMENT_ID")}</b>
                {/* Sort indication */}
                {props.sortBy === "subAdjustmentId" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell>
                <b>{props.t("NAME")}</b>
              </TableCell>
              <TableCell>
                <b>{props.t("ADJUSTMENT_TYPE")}</b>
              </TableCell>
              <TableCell>
                <b>{props.t("ADJUSTMENT_VALUE")}</b>
              </TableCell>
              <TableCell>
                <b>{props.t("DATE")}</b>
              </TableCell>
              <TableCell>
                <b>{props.t("DESCRIPTION")}</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Show orders list */}

            <TableRow
              hover
              className={
                classes.rowClass + " " + "subscriptionAdjustmentTableRow"
              }
            >
              <TableCell component="th" scope="row">
                {" "}
                {props.subscriptionAdjustments.adjustmentId}
              </TableCell>
              <TableCell>{props.subscriptionAdjustments.name} </TableCell>
              <TableCell>{props.subscriptionAdjustments.type} </TableCell>
              <TableCell>
                {" "}
                {props.subscriptionAdjustments.value
                  ? props.subscriptionAdjustments.value.amount
                  : null}
              </TableCell>
              <TableCell>
                {formatDate(props.subscriptionAdjustments.createdTimestamp)}
              </TableCell>
              <TableCell>{props.subscriptionAdjustments.description}</TableCell>
            </TableRow>

            {/* If there is no adjustment to show */}
            {props.showLoading && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  {props.t("LOADING")}
                </TableCell>
              </TableRow>
            )}
            {!props.showLoading &&
              props.subscriptionAdjustments.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    {props.t("NO_ADJUSTMENT_FOUND")}
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
      {props.totalOrderCount > 0 && (
        <div
          className="global-custom-pagination"
          style={{ background: "rgba(196, 196, 196, 0.2)" }}
        >
          <label style={{ float: "left", padding: "5px" }}>
            {props.t("TOTAL_RECORDS")}: {formatNumber(props.totalOrderCount)}
          </label>
          <label>
            {/* Rows per page select */}
            {props.t("ROWS_PER_PAGE")}:
            <Select
              value={props.rowsPerPage}
              onChange={props.handleChangeRowsPerPage}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </label>
          {/* Pagination component */}
          <Pagination
            count={Math.ceil(props.totalOrderCount / props.rowsPerPage)}
            onChange={props.handleChangePage}
            page={props.page}
            showFirstButton
            showLastButton
          />
        </div>
      )}
    </div>
  );
};

export default withTranslation("translations")(subscriptionAdjustmentTable);
